// File: Spinner.jsx

import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { useLoading } from './LoadingContext';

const StyledSpinner = styled('div')(() => ({
  position: 'fixed',
  width: '100%',
  height: '100vh',
  background: '#00000059',
  zIndex: 9999,
}));

const StyledStrong = styled('strong')(() => ({
  position: 'absolute',
  top: '46%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: '15px',
  fontWeight: 500,
  color: '#fff',
}));

const StyledBox = styled(Box)(() => ({
  width: '150px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#FFF',
  margin: 0,
  padding: '3px',
  borderRadius: '50px',
}));

const StyledLinearProgress = styled(LinearProgress)(() => ({
  height: '10px',
  borderRadius: '8px',
  backgroundColor: '#fff', // base background
  '& .MuiLinearProgress-bar1Buffer': {
    background: 'linear-gradient(108deg, #2985a8 -17.68%, #e03f40 99.18%)',
    borderRadius: '8px',
  },
  '& .MuiLinearProgress-dashed': {
    backgroundColor: '#fff',
  },
}));


const Spinner = () => {
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);
  const { loading } = useLoading();
  const progressRef = useRef(() => {});

  useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(5);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(prev => prev + diff);
        setBuffer(prev => prev + diff + diff2);
      }
    };
  }, [progress]);

  useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 50);

    return () => clearInterval(timer);
  }, []);

  if (!loading) return null;

  return (
    <StyledSpinner>
      <StyledStrong>Loading ...</StyledStrong>
      <StyledBox>
        <StyledLinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
      </StyledBox>
    </StyledSpinner>
  );
};

export default Spinner;
